import axios from 'axios';

export default {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    setNews(state, data) {
      state.list = data;
    },
  },
  actions: {
    fetchFromServer({ commit }) {
      axios.get('/api/news')
        .then(response => commit('setNews', response.data))
        .catch(error => console.log(error));
    },
  },
};
